export function scrollToId(aid, offset) {
    var elem = $(aid);
    $("html,body").animate({
        scrollTop: elem.offset().top - offset
    }, "slow");
}